import { useEffect } from "react";
import { http } from "@/lib/api";
import { logWarn } from "@/lib/log";

export const THEME_KEY = "brynai.theme";
const prefersLight = () => window.matchMedia("(prefers-color-scheme: light)").matches;
export const effectiveTheme = (t) => (t === "system" ? (prefersLight() ? "light" : "dark") : t || "dark");

// Signed-in pages only: the account setting wins, the device copy stops a flash on the next load (see public/index.html).
export function useAppTheme(theme) {
  useEffect(() => {
    if (theme) localStorage.setItem(THEME_KEY, theme);
    const apply = () => document.documentElement.classList.toggle("light", effectiveTheme(theme) === "light");
    apply();
    const mq = window.matchMedia("(prefers-color-scheme: light)");
    mq.addEventListener("change", apply);
    return () => { mq.removeEventListener("change", apply); document.documentElement.classList.remove("light"); };
  }, [theme]);
}

export async function saveTheme(theme, setUser) {
  localStorage.setItem(THEME_KEY, theme);
  setUser((u) => (u ? { ...u, theme } : u));
  try { await http.put("/account/prefs", { theme }); } catch (e) { logWarn("Couldn't save theme", e); }
}
